export default {
  pleaseEnterLine: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000D9A","请填写第") /* "请填写第" */,
  lineDepartment: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000D9B","行部门") /* "行部门" */,
  noOrgSave: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000D9C","保存成功，请继续维护组织信息") /* "保存成功，请继续维护组织信息" */,
  operationSuccess: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000D9D","保存成功") /* "保存成功" */
};
